export const renderIntegrations = (
  integrations: { google_analytics_id?: string; facebook_pixel_id?: string } | undefined
) => {
  if (!integrations) return null;

  return (
    <>
      {integrations.google_analytics_id && (
        <>
          <script
            key="ga-src"
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${integrations.google_analytics_id}`}
          />
          <script
            key="ga-init"
            dangerouslySetInnerHTML={{
              __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${integrations.google_analytics_id}');
              `,
            }}
          />
        </>
      )}

      {/* Facebook Pixel scripts */}
      {!isNaN(Number(integrations.facebook_pixel_id)) && (
        <script
          key="fb-pixel"
          dangerouslySetInnerHTML={{
            __html: `
              !function(f,b,e,v,n,t,s) {
                if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${integrations.facebook_pixel_id}');
                fbq('track', 'PageView');
              `,
          }}
        />
      )}
    </>
  );
};
